const inputViewNew = {
  placeholder: 'Escriba aquí...'
};

export default inputViewNew;
